import './init'
import Form from './form'
import ExtensionService from 'live/services/extension'

const mqtt = {
    name: 'MQTT Client',
    type: 'mqttinputclient',
    origin: 'Plugin MQTT',
    roles: ['input'],
    icon: '/content/plugin-mqtt-client/mqttimg.png',
    ui: {
        form: Form,
        view: null
    }
}

ExtensionService.register(mqtt);
